import { useStoreActions, useStoreState } from "easy-peasy"
import { Link } from "react-router-dom"

const Nav = () => {
	// Easy-Peasy
	const LoggedIn = useStoreState((state) => state.LoggedIn)
	const AuthUser = useStoreState((state) => state.AuthUser)
	const AuthDMV = useStoreState((state) => state.AuthDMV)
	const AuthDashboard = useStoreState((state) => state.AuthDashboard)
	const AuthAnimal = useStoreState((state) => state.AuthAnimal)
	const AuthFarm = useStoreState((state) => state.AuthFarm)
	const AuthReports = useStoreState((state) => state.AuthReports)
	const NavSelected = useStoreState((state) => state.NavSelected)
	const setNavSelected = useStoreActions((actions) => actions.setNavSelected)
	const NavSubSelected = useStoreState((state) => state.NavSubSelected)
	const setNavSubSelected = useStoreActions(
		(actions) => actions.setNavSubSelected,
	)
	function navStyle(key) {
		return NavSelected === key
			? { color: "var(--nav-selected)", backgroundColor: "#333" }
			: { color: "#fff", backgroundColor: "#333" }
	}

	function subNavClass(key) {
		return NavSubSelected === key ? "nav_sub_selected" : ""
	}

	// Records which nav item is highlighted. It must NOT navigate: every entry
	// already has a <Link> carrying the real destination. When the onClick sits on
	// the wrapping <div>, the Link navigates first and the bubbled handler ran
	// last, so a navigate(route) here overwrote the Link with the *key* — which
	// only happened to work while every key equalled its path ("duplicates" ->
	// /duplicates instead of /license/duplicates was the first one to differ).
	function handleNav(route) {
		setNavSelected(route)
	}

	return (
		<nav className="Nav">
			{/* {LoggedIn && (
				<div onClick={() => handleNav("home")}>
					<Link to="/home" style={navStyle("home")}>
						Home
					</Link>
				</div>
			)} */}
			{LoggedIn && (
				<div onClick={() => handleNav("configure")}>
					<Link to="/configure" style={navStyle("configure")}>
						Configure
					</Link>
				</div>
			)}
			{LoggedIn && AuthAnimal && (
				<div className="nav_dropdown">
					<Link
						to="/dog/dogtags"
						style={navStyle("dog")}
						onClick={() => { handleNav("dog"); setNavSubSelected("dog/dogtags") }}
					>
						Tag Setup ▾
					</Link>
					<div className="nav_dropdown_content">
							<Link
							to="/dog/fees"
							className={subNavClass("dog/fees")}
							onClick={() => {
								handleNav("dog")
								setNavSubSelected("dog/fees")
							}}
						>
							Fees
						</Link>
						<Link
							to="/dog/dogtags"
							className={subNavClass("dog/dogtags")}
							onClick={() => {
								handleNav("dog")
								setNavSubSelected("dog/dogtags")
							}}
						>
							Tag Management
						</Link>
					</div>
				</div>
			)}
			{LoggedIn && AuthAnimal && (
				<div onClick={() => handleNav("license")}>
					<Link to="/license/taxpayerfind" style={navStyle("license")}>
						License
					</Link>
				</div>
			)}
			{LoggedIn && AuthAnimal && (
				<div onClick={() => handleNav("duplicates")}>
					<Link to="/license/duplicates" style={navStyle("duplicates")}>
						Duplicates
					</Link>
				</div>
			)}
			{LoggedIn && AuthDMV && (
				<div onClick={() => handleNav("dmv")}>
					<Link to="/dmv" style={navStyle("dmv")}>
						DMV
					</Link>
				</div>
			)}
			{LoggedIn && AuthDashboard && (
				<div onClick={() => handleNav("dashboard")}>
					<Link to="/dashboard" style={navStyle("dashboard")}>
						Dashboard
					</Link>
				</div>
			)}
			{LoggedIn && AuthFarm && (
				<div onClick={() => handleNav("farm")}>
					<Link to="/farm" style={navStyle("farm")}>
						Farm
					</Link>
				</div>
			)}
			{LoggedIn && AuthReports && (
				<div className="nav_dropdown">
					<Link
						to="/reports"
						style={navStyle("reports")}
						onClick={() => handleNav("reports")}
					>
						Reports ▾
					</Link>
					<div className="nav_dropdown_content">
						<Link
							to="/reports?category=dog"
							className={subNavClass("reports/dog")}
							onClick={() => { handleNav("reports"); setNavSubSelected("reports/dog") }}
						>
							Dog
						</Link>
						<Link
							to="/reports?category=farm"
							className={subNavClass("reports/farm")}
							onClick={() => { handleNav("reports"); setNavSubSelected("reports/farm") }}
						>
							Farm
						</Link>
					</div>
				</div>
			)}
			{LoggedIn && AuthUser && (
				<div className="nav_dropdown">
					<Link
						to="/user"
						style={navStyle("user")}
						onClick={() => handleNav("user")}
					>
						Staff ▾
					</Link>
					<div className="nav_dropdown_content">
						<Link
							to="/useradd"
							className={subNavClass("useradd")}
							onClick={() => {
								handleNav("useradd")
								setNavSubSelected("useradd")
							}}
						>
							Add User
						</Link>
						<Link
							to="/user"
							className={subNavClass("user")}
							onClick={() => {
								handleNav("user")
								setNavSubSelected("user")
							}}
						>
							List Users
						</Link>
					</div>
				</div>
			)}
			{!LoggedIn && (
				<div onClick={() => handleNav("login")}>
					<Link to="/login" style={navStyle("login")}>
						Login
					</Link>
				</div>
			)}
			{LoggedIn && (
				<div onClick={() => handleNav("help")}>
					<Link to="/help" style={navStyle("help")}>
						Help
					</Link>
				</div>
			)}
			{LoggedIn && (
				<div onClick={() => handleNav("logout")}>
					<Link to="/logout" style={navStyle("logout")}>
						Logout
					</Link>
				</div>
			)}
		</nav>
	)
}

export default Nav
